module.exports = __webpack_public_path__ + "static/aga-medal-dcc72a1373125583ce360069514dab06.png";